module.exports = __webpack_public_path__ + "img/der_02_stone.a0a250f6.png";